<template>
    <div class="col-sm-12" v-loading="loading">
        <div style="display: flex; justify-content: space-between">
            <h2>Quotes</h2>
            <div>
                <a class="btn btn-danger is-aligned-right" :href="url(`/admin/quotes/new?employer_id=${employer_id}`)">
                    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span> New
                </a>
            </div>
        </div>

        <div>
            <form class="filter-group list-filter" style="display: flex; flex-wrap: wrap;">
                <div class="form-group"><label>From</label> <input type="date" class="form-control" v-model="filter.date_from"></div>
                <div class="form-group"><label>To</label> <input type="date" class="form-control" v-model="filter.date_to"></div>
                <div class="form-group">
                    <label style="display: block">Author</label>
                    <el-select v-model="filter.author" filterable>
                        <el-option :value="null">...</el-option>
                        <el-option :label="o.name" :key="o.id" :value="o.id" v-for="o in users"></el-option>
                    </el-select>
                </div>
                <div class="form-group"><label>Search</label> <input type="text" class="form-control" v-model="filter.search"></div>
                <div class="form-group" style="padding-top: 25px">
                    <btn cssClass="btn btn-secondary" icon="fas fa-redo-alt" :click="refresh">Filter</btn>
                </div>
            </form>
        </div>

        <div>
            <table class="table table-striped table-hover table-sticky-header custom-table">
                <thead>
                <tr>
                    <th>Author</th>
                    <th>Created</th>
                    <th>Name</th>
                    <th>Prefilled from</th>
                    <th style="text-align: right;">Suggested Budget</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in rows">
                    <td>{{ row.created_by }}</td>
                    <td>{{ row.date }}</td>
                    <td>{{ row.name }}</td>
                    <td v-if="row.campaigns_count > 0">
                        <b>Campaign{{ row.campaigns_count > 1 ? 's' : '' }}:</b> {{ row.campaigns }}
                    </td>
                    <td v-else-if="row.jobs_count > 0">
                        <b>Job{{ row.jobs_count > 1 ? 's' : '' }}:</b> {{ row.jobs }}
                    </td>
                    <td v-else></td>
                    <td style="text-align: right;">{{ my_money(row.budget) }}</td>
                    <td><a :href="url(`admin/quotes/${row.id}/ppa-quote`)">PPA Quote</a></td>
                    <td><a :href="url(`admin/quotes/${row.id}/clone`)">Clone</a></td>
                    <td><a :href="url(`admin/quotes/${row.id}/detail`)">Update</a></td>
                    <td><a :href="url(`admin/quotes/${row.id}/delete`)">Delete</a></td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <th></th>
                    <th></th>
                    <th>Total {{ total_rows }}</th>
                    <th></th>
                    <th style="text-align: right;">{{ my_money(total_budget) }}</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                </tfoot>
            </table>
        </div>

        <employer-notes-wrapper :employer-id="employer_id" />
    </div>
</template>

<script>
export default {
    props: [
        'employer_id',
    ],
    components: {
    },
    data() {
        return {
            filter: {
                author: null,
                date_from: null,
                date_to: null,
                employer_id: this.employer_id,
            },
            users: [],
            employers: [],
            campaigns: {},
            rows: [],
            loading: true,
        };
    },
    computed: {
        total_rows() {
            return this.rows.length;
        },
        total_budget() {
            return _.sum(_.map(this.rows, (r) => parseFloat(r.budget) || 0));
        },
    },
    methods: {
        refresh() {
            this.loading = true;
            return axios.get(url(`admin/employer/${this.employer_id}/quotes/data`), { params: this.filter })
                        .then((response) => {
                            this.rows = response.data.list;
                            this.campaigns = response.data.campaigns;
                            this.loading = false;
                        });
        },
        my_money(m) {
            return numeral(m).format('$ 0,0')
        }
    },
    mounted() {
        this.refresh();
        axios.get(url(`admin/user/dropdown`))
             .then((response) => {
                 this.users = response.data;
             });
    }
}
</script>

<style>
</style>
